import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";

export type HandlerType = Parameters<typeof PopulateApiParameter>[0];

addToChainAfter(chain, PopulateApiParameter, IncludePickUpWarehouseOnShipping);

export function IncludePickUpWarehouseOnShipping(props: HandlerType) {
    // B2BES [TDP-53] - MODIFY Customization - Handler chain was overriding pickup warehouse when delivery method was shipping
    props.apiParameter.session.pickUpWarehouse = props.parameter.pickUpWarehouse;
}
